<template>
  <div>
    <!-- Modal -->
    <div
      class="modal fade"
      id="inActiveModal"
      data-backdrop="static"
      data-keyboard="false"
      tabindex="-1"
      aria-labelledby="staticBackdropLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered idleModal-dialog">
        <div class="modal-content">
          <div class="modal-body inAct-modal-body text-center">
            <p class="inActive-text">
              Uw scherm is geblokkeerd vanwege inactiviteit.
            </p>
            <router-link :to="{name: 'login'}"  class="btn btn-dark mt-3" data-dismiss="modal">Terug naar inloggen</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- create committee modal end-->
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>

<style scoped>
.inAct-inp {
  box-shadow: none !important;
  border: 1px solid #ced4da !important;
  height: 44px !important;
}

.inAct-modal-body {
  padding: 1.8rem !important;
}

.inActiveBtn {
  position: absolute;
  bottom: 162px;
}
.idleModal-dialog {
  max-width: 400px !important;
}
.idle-btn-t {
  text-decoration: none;
  font-size: 16px;
}
</style>
